var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderEvents01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calender Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.56,
    y1: 16.3,
    x2: 10.33,
    y2: 16.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.56,
    y1: 12.01,
    x2: 14.15,
    y2: 12.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.62,7.6v11L17.22,23H3.14a1.76,1.76,0,0,1-1.76-1.76V7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.62,18.6,17.22,23V20.36A1.76,1.76,0,0,1,19,18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.86,2.76a1.76,1.76,0,0,1,1.76,1.76V7.6H1.38V4.52A1.76,1.76,0,0,1,3.14,2.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.67,
    y1: 2.76,
    x2: 17.44,
    y2: 2.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.24,1h0a1.1,1.1,0,0,1,1.1,1.1V3.42a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1V2.1A1.1,1.1,0,0,1,4.24,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.76,1h0a1.1,1.1,0,0,1,1.1,1.1V3.42a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1V2.1A1.1,1.1,0,0,1,18.76,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderEvents01);
export default __webpack_public_path__ + "static/media/Calender_Events_01.83bf2310b25c1fe46f04ab5122261580.svg";
export { ForwardRef as ReactComponent };